var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("h2", { staticClass: "card-title" }, [
        _vm._v(_vm._s(_vm.T.loginHeader))
      ])
    ]),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row justify-content-md-center" }, [
        _c("div", { staticClass: "col-md-4 col-md-offset-2" }, [
          _c("h4", [_vm._v(_vm._s(_vm.T.loginFederated))]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-4 text-center py-2" }, [
              _c("div", {
                attrs: {
                  id: "g_id_onload",
                  "data-client_id": _vm.googleClientId,
                  "data-login_uri": _vm.loginUri,
                  "data-auto_prompt": "false"
                }
              }),
              _c("div", {
                staticClass: "g_id_signin",
                attrs: {
                  "data-type": "standard",
                  "data-size": "large",
                  "data-theme": "outline",
                  "data-text": "signin_with",
                  "data-shape": "rectangular",
                  "data-logo_alignment": "left"
                }
              })
            ])
          ])
        ]),
        _c("div", { staticClass: "col-md-4 col-md-offset-2" }, [
          _c("h4", [_vm._v(_vm._s(_vm.T.loginNative))]),
          _c("form", { staticClass: "form-horizontal" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "user" } }, [
                _vm._v(_vm._s(_vm.T.loginEmailUsername))
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.usernameOrEmail,
                    expression: "usernameOrEmail"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  "data-login-username": "",
                  name: "login_username",
                  type: "text",
                  tabindex: "1",
                  autocomplete: "username"
                },
                domProps: { value: _vm.usernameOrEmail },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.usernameOrEmail = $event.target.value
                  }
                }
              })
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "pass" } }, [
                _vm._v(_vm._s(_vm.T.loginPassword) + " ("),
                _c("a", { attrs: { href: "/login/password/recover/" } }, [
                  _vm._v(_vm._s(_vm.T.loginRecover))
                ]),
                _vm._v(")")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  "data-login-password": "",
                  name: "login_password",
                  type: "password",
                  tabindex: "2",
                  autocomplete: "current-password"
                },
                domProps: { value: _vm.password },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  }
                }
              })
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary form-control",
                  attrs: { "data-login-submit": "", name: "login" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$emit(
                        "login",
                        _vm.usernameOrEmail,
                        _vm.password
                      )
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.T.loginLogIn) + " ")]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }